var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75586 7.04066C5.75586 5.82303 6.76054 4.83594 7.99995 4.83594C9.23936 4.83594 10.244 5.82303 10.244 7.04066C10.244 8.25832 9.23936 9.24539 7.99995 9.24539C6.76055 9.24539 5.75586 8.25832 5.75586 7.04066ZM7.99995 5.9383C7.38024 5.9383 6.87791 6.43184 6.87791 7.04066C6.87791 7.64951 7.38024 8.14302 7.99995 8.14302C8.61967 8.14302 9.122 7.64951 9.122 7.04066C9.122 6.43184 8.61966 5.9383 7.99995 5.9383Z",
    fill: "#727190"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.02505C3 4.24979 5.23858 2 8 2C10.7614 2 13 4.24979 13 7.02505C13 8.43552 12.3629 9.67172 11.4957 10.8033C10.7711 11.749 9.84364 12.673 8.91715 13.596C8.74189 13.7707 8.56665 13.9452 8.39284 14.1199C8.17588 14.338 7.82412 14.338 7.60716 14.1199C7.43335 13.9452 7.25812 13.7707 7.08285 13.596C6.15636 12.673 5.22891 11.749 4.50429 10.8033C3.63713 9.67172 3 8.43552 3 7.02505ZM8 3.11668C5.85223 3.11668 4.11111 4.86652 4.11111 7.02505C4.11111 8.08149 4.58509 9.07866 5.3846 10.122C6.05966 11.0029 6.92372 11.8643 7.85123 12.7889C7.90065 12.8382 7.95024 12.8876 8 12.9373C8.04976 12.8876 8.09935 12.8382 8.14877 12.7889C9.07628 11.8643 9.94034 11.0029 10.6154 10.122C11.4149 9.07866 11.8889 8.08149 11.8889 7.02505C11.8889 4.86652 10.1478 3.11668 8 3.11668Z",
    fill: "#727190"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.69010a65c4c6cb563364ded241bfee06.svg";
export { ForwardRef as ReactComponent };